import {createSelector} from 'reselect';
import * as _ from 'lodash';
import {IPowerSource} from '../../data/data';
import {countPowerSourcesByType, getPowerSources} from './powerSources';
import {AnyAction} from 'redux';
import {SAVE_POWER_SOURCE_COUNTS} from '../actions/action';

export interface PowerSourceCounts
{
    [id: string]: number;
}

export const getSavedPowerSourceCounts = (state) => state.savedPowerSourceCounts;


/**
 * count the change in the number of power sources for all types from the start of the year
 */
export const countPowerSourceDifferencesByType = createSelector(

    [getSavedPowerSourceCounts, countPowerSourcesByType],

    (saved_counts: PowerSourceCounts, current_counts: PowerSourceCounts) : PowerSourceCounts =>
    {
        return _.transform(saved_counts, (result_counts: PowerSourceCounts, saved_count: number, source_id: string) =>
        {
            result_counts[source_id] = saved_count - current_counts[source_id];

            return result_counts;
        }, {})
    }
);


/**
 * reducer: save a snapshot of the current number of each type of power sources
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function savedPowerSourceCounts(state = {}, action: AnyAction) : PowerSourceCounts
{
    switch (action.type)
    {
        case SAVE_POWER_SOURCE_COUNTS:
        {
            const {payload} = action;
            const {counts} = payload;

            return counts;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/savedPowerSourceCounts.ts